import { Flex } from "antd";
import styled from "styled-components";

export const Summary = styled.div``;

export const SummaryButton = styled(Flex)`
  width: 100%;
  justify-content: flex-end;

  ${({ theme }) => theme.breakpoints.up("md")} {
    width: auto;
  }
`;

export const SummaryTitle = styled.h2`
  font-size: 16px;
  margin-bottom: 10px;
`;
